import { application } from "./application"
import ActivePageActivationController from "./bridge/active_page_activation_controller"
import AudioController from "./bridge/audio_controller"
import AccountDeletionController from "./account_deletion_controller"

import ClockController from "./clock_controller"
import ConnectionRecoveryController from "./bridge/connection_recovery_controller"
import DashboardRevalidationController from "./dashboard_revalidation_controller"
import DialogController from "./dialog_controller"
import DialogFrameController from "./dialog_frame_controller"
import PurchasePickerController from "./purchase_picker_controller"
import DialogBackController from "./bridge/dialog_back_controller"
import FlashController from "./flash_controller"
import GoogleSignInController from "./bridge/google_sign_in_controller"
import IdentityAvatarController from "./identity_avatar_controller"
import FeatureManagementController from "./feature_management_controller"
import FleetSliderController from "./fleet_slider_controller"
import FrameRecoveryController from "./frame_recovery_controller"
import FocusHeadingController from "./focus_heading_controller"
import OfficeActivationController from "./bridge/office_activation_controller"
import OfficeRevalidationController from "./office_revalidation_controller"
import PublicDraftController from "./public_draft_controller"
import PublicMenuController from "./public_menu_controller"
import PublicSessionController from "./public_session_controller"
import MachineRevalidationController from "./machine_revalidation_controller"
import MachineActivityController from "./machine_activity_controller"
import SliderSelectionController from "./slider_selection_controller"
import SubmitOnceController from "./submit_once_controller"
import TerminalRootRevalidationController from "./terminal_root_revalidation_controller"
import ToggletipController from "./toggletip_controller"
import SuppliersRevalidationController from "./suppliers_revalidation_controller"

application.register("active-page-activation", ActivePageActivationController)
application.register("audio", AudioController)
application.register("account-deletion", AccountDeletionController)

application.register("clock", ClockController)
application.register("connection-recovery", ConnectionRecoveryController)
application.register("dashboard-revalidation", DashboardRevalidationController)
application.register("dialog", DialogController)
application.register("dialog-frame", DialogFrameController)
application.register("purchase-picker", PurchasePickerController)
application.register("dialog-back", DialogBackController)
application.register("flash", FlashController)
application.register("google-sign-in", GoogleSignInController)
application.register("identity-avatar", IdentityAvatarController)
application.register("feature-management", FeatureManagementController)
application.register("fleet-slider", FleetSliderController)
application.register("frame-recovery", FrameRecoveryController)
application.register("focus-heading", FocusHeadingController)
application.register("office-activation", OfficeActivationController)
application.register("office-revalidation", OfficeRevalidationController)
application.register("public-draft", PublicDraftController)
application.register("public-menu", PublicMenuController)
application.register("public-session", PublicSessionController)
application.register("machine-revalidation", MachineRevalidationController)
application.register("machine-activity", MachineActivityController)
application.register("slider-selection", SliderSelectionController)
application.register("submit-once", SubmitOnceController)
application.register("terminal-root-revalidation", TerminalRootRevalidationController)
application.register("toggletip", ToggletipController)
application.register("suppliers-revalidation", SuppliersRevalidationController)
